export enum SaleOrderStatusCategory {
    OPERATIONAL = 1,
    FINANCIAL = 2,
    SHIPMENT = 3,
}

export interface IStatusType {
    empactStatusId: number;
    statusType: SaleOrderStatusCategory;
    /** Display label used by the filter pipe search */
    name?: string;
}

export interface ISaleOrderStatusHistoryRow {
    id: number;
    saleOrderId: number;
    empactStatusId: number;
    statusDate: string;
    statusReason?: string;
    statusType?: IStatusType;
}
